import React, { useEffect, useState } from 'react';
import Get from '../../api/internal/Get';
import OptionList from '../../helpers/options/OptionList';
import Button from '../../assets/essentials/Button';
import classes from './CreateEvent.module.css';
import PostBody from '../../api/internal/PostBody';

const CreateEvent = () => {
  const [driverOptions, setDriverOptions] = useState<DriverOption[]>([]);
  const [eventTypeOptions, setEventTypeOptions] = useState<EventTypeOption[]>(
    [],
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isAllDay, setIsAllDay] = useState(false);

  useEffect(() => {
    Get('Employee/GetDriverOptions').then(res => {
      if (res) {
        setDriverOptions(res.data);
      }
    });
    Get('Schedule/GetEventTypes').then(res => {
      if (res) {
        setEventTypeOptions(res.data);
      }
    });
  }, []);

  const onSuccess = () => {
    setIsSuccess(true);
    setIsLoading(false);

    //reset success state after 3 seconds
    setTimeout(() => {
      setIsSuccess(false);
    }, 3000);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true);
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const startDate = formData.get('startDate') as string;
    const startTime = formData.get('startTime') as string;
    const endDate = formData.get('endDate') as string;
    const endTime = formData.get('endTime') as string;
    const isAllDayChecked = (formData.get('isAllDay') as string) === 'on';

    // Combine date and time if not all day
    const startDateTime =
      isAllDayChecked || !startTime
        ? startDate
        : `${startDate}T${startTime}:00`;

    const endDateTime =
      isAllDayChecked || !endTime || !endDate
        ? endDate || null
        : `${endDate}T${endTime}:00`;

    PostBody('Schedule/CreateDriverEvent', {
      driverId: formData.get('driverId'),
      eventTypeId: formData.get('eventTypeId'),
      requestedDate: formData.get('requestedDate'),
      startDate: startDateTime,
      endDate: endDateTime,
      isAllDay: isAllDayChecked,
      notes: formData.get('notes'),
    })
      .then(res => {
        if (res) {
          onSuccess();
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className={classes.container}>
      <h1 className={classes.header}>Create Event</h1>
      <form onSubmit={handleSubmit} className={classes.form}>
        <div className={classes.formGroup}>
          <label htmlFor="driverId">Driver</label>
          <select name="driverId" id="driverId" required>
            <option value="" hidden>
              Select a driver
            </option>
            <OptionList
              optionData={driverOptions}
              attributeID="driverId"
              attributeName="name"
            />
          </select>
        </div>

        <div className={classes.formGroup}>
          <label htmlFor="eventTypeId">Event Type</label>
          <select name="eventTypeId" id="eventTypeId" required>
            <OptionList
              optionData={eventTypeOptions}
              attributeID="eventTypeId"
              attributeName="typeName"
            />
          </select>
        </div>

        <div className={classes.formRow}>
          <div className={classes.formGroup}>
            <label htmlFor="requestedDate">Requested Date</label>
            <input
              name="requestedDate"
              id="requestedDate"
              type="date"
              required
              defaultValue={new Date().toISOString().split('T')[0]}
            />
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.formGroup}>
            <label htmlFor="startDate">Start Date</label>
            <input name="startDate" id="startDate" type="date" required />
          </div>

          {!isAllDay && (
            <div className={classes.formGroup}>
              <label htmlFor="startTime">Start Time</label>
              <input name="startTime" id="startTime" type="time" />
            </div>
          )}

          <div className={classes.formGroup}>
            <label htmlFor="endDate">End Date</label>
            <input name="endDate" id="endDate" type="date" />
          </div>

          {!isAllDay && (
            <div className={classes.formGroup}>
              <label htmlFor="endTime">End Time</label>
              <input name="endTime" id="endTime" type="time" />
            </div>
          )}
        </div>

        <div className={classes.checkboxGroup}>
          <label htmlFor="isAllDay">All Day Event</label>
          <input
            name="isAllDay"
            id="isAllDay"
            type="checkbox"
            checked={isAllDay}
            onChange={e => setIsAllDay(e.target.checked)}
          />
        </div>

        <div className={classes.formGroup}>
          <label htmlFor="notes">Notes</label>
          <textarea name="notes" id="notes" rows={4} />
        </div>

        <div className={classes.submitButton}>
          <Button
            type="submit"
            variant="good"
            disabled={isLoading || isSuccess}
            isLoading={isLoading}
          >
            Create Event
          </Button>
          {isSuccess && <p>Event Created ✅</p>}
        </div>
      </form>
    </div>
  );
};

export default CreateEvent;
